package com.eladfinish.bible.contest.screens.openQuestions.menu

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.add_question
import com.eladfinish.bible.contest.create_your_own_qna
import com.eladfinish.bible.contest.help
import com.eladfinish.bible.contest.menu_refresh
import com.eladfinish.bible.contest.more_open_questions
import com.eladfinish.bible.contest.table_of_contents
import com.eladfinish.bible.contest.ui.components.toolbar.SetToolbarConfiguration
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionConfig
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarActionPlacement
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarConfiguration
import com.eladfinish.bible.contest.ui.components.toolbar.configuration.model.ToolbarHeaderComponentConfig
import com.eladfinish.bible.contest.ui.components.toolbar.model.ToolbarKind
import com.eladfinish.bible.contest.ui.menus.actions.OpenQuestionsToolbarAction
import com.eladfinish.bible.contest.ui.menus.actions.ToolbarActionEmitter
import dev.icerock.moko.resources.desc.desc
import kotlinx.collections.immutable.toImmutableList

enum class OpenQuestionsToolbarId {
    MORE_QUESTIONS,
    TABLE_OF_CONTENTS,
    HELP,
    ADD_QUESTION,
    CREATE_YOUR_OWN_QNA,
    REFRESH,
}


@Composable
internal fun OpenQuestionsMenu(
    title: String,
    toolbarEmitter: ToolbarActionEmitter<OpenQuestionsToolbarAction>,
    showMoreQuestionsAction: Boolean = true,
) {
    SetToolbarConfiguration(
        configuration = ToolbarConfiguration(
            kind = ToolbarKind.OpenQuestions,
            title = ToolbarHeaderComponentConfig.Text(text = title),
            actions = listOfNotNull(
                ToolbarActionConfig.TextActionRes(
                    id = OpenQuestionsToolbarId.MORE_QUESTIONS,
                    stringDesc = SharedRes.strings.more_open_questions.desc(),
                    onClick = {
                        toolbarEmitter.emit(OpenQuestionsToolbarAction.MoreQuestions)
                    },
                    placement = ToolbarActionPlacement.OnToolbar,
                ).takeIf { showMoreQuestionsAction },
                ToolbarActionConfig.TextActionRes(
                    id = OpenQuestionsToolbarId.TABLE_OF_CONTENTS,
                    stringDesc = SharedRes.strings.table_of_contents.desc(),
                    onClick = {
                        toolbarEmitter.emit(OpenQuestionsToolbarAction.TableOfContents)
                    },
                    placement = ToolbarActionPlacement.InOverflow,
                ),
                ToolbarActionConfig.TextActionRes(
                    id = OpenQuestionsToolbarId.HELP,
                    stringDesc = SharedRes.strings.help.desc(),
                    onClick = {
                        toolbarEmitter.emit(OpenQuestionsToolbarAction.Help)
                    },
                    placement = ToolbarActionPlacement.InOverflow,
                ),
                ToolbarActionConfig.TextActionRes(
                    id = OpenQuestionsToolbarId.ADD_QUESTION,
                    stringDesc = SharedRes.strings.add_question.desc(),
                    onClick = {
                        toolbarEmitter.emit(OpenQuestionsToolbarAction.AddQuestion)
                    },
                    placement = ToolbarActionPlacement.InOverflow,
                ),
                ToolbarActionConfig.TextActionRes(
                    id = OpenQuestionsToolbarId.CREATE_YOUR_OWN_QNA,
                    stringDesc = SharedRes.strings.create_your_own_qna.desc(),
                    onClick = {
                        toolbarEmitter.emit(OpenQuestionsToolbarAction.CreateYourOwnQnA)
                    },
                    placement = ToolbarActionPlacement.InOverflow,
                ),
                ToolbarActionConfig.TextActionRes(
                    id = OpenQuestionsToolbarId.REFRESH,
                    stringDesc = SharedRes.strings.menu_refresh.desc(),
                    onClick = {
                        toolbarEmitter.emit(OpenQuestionsToolbarAction.Refresh)
                    },
                    placement = ToolbarActionPlacement.InOverflow,
                ),
            ).toImmutableList()
        )
    )
}
